/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon20Solid = forwardRef('MediaAudioWaveIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 3a1 1 0 0 0-2 0v14a1 1 0 1 0 2 0V3Z" }),
        React.createElement("path", { d: "M16 5a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V5Z" }),
        React.createElement("path", { d: "M19 8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V8Z" }),
        React.createElement("path", { d: "M12 6.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M6 5a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M4 8.5a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0v-3Z" })));
});
